var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-header"},[_c('div',{staticClass:"left"},[_c('img',{staticClass:"logo",attrs:{"src":require('@/assets/imgs/login_logo.png')}}),_c('Navigation')],1),_c('UserInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }